import React from 'react';
import { useSelector } from 'react-redux';
import { selectedToggleValue } from '../../redux/canvasResolutionSlice';
import MegaMenuVertical from './MegaMenuVertical';
import MegaMenuHorizontal from './MegaMenuHorizontal';
import './megaMenuStyles.scss';

const Wrapper = ({ blockClass, orientation, title, openOnly, componentId }) => {
	const selectedCanvasResolution = useSelector(selectedToggleValue);
	const isMobile = selectedCanvasResolution <= 1024 ? true : false;
	const orientationMenu = isMobile ? 'vertical' : 'horizontal';

	if (isMobile) {
		return (
			<MegaMenuVertical
				openOnly={openOnly || 'vertical'}
				orientation={orientation}
				blockClass={blockClass}
				title={title}
				isMobile={isMobile}
				componentId={componentId}
			/>
		);
	}

	if (orientationMenu === 'vertical') {
		return (
			<MegaMenuVertical
				openOnly={openOnly || 'vertical'}
				orientation={orientation}
				blockClass={blockClass}
				title={title}
			/>
		);
	}

	return (
		<MegaMenuHorizontal
			openOnly={openOnly || 'horizontal'}
			orientation={orientationMenu}
			blockClass={blockClass}
			title={title}
		/>
	);
};

export default Wrapper;
